// extracted by mini-css-extract-plugin
export var bodyRow = "_gf-d";
export var cardColumns = "_gf-e";
export var ellipsesOverflow = "_gf-2";
export var flatBottomCorners = "_gf-3";
export var flatTopCorners = "_gf-4";
export var headerActionsDropdown = "_gf-f";
export var headerBottomRow = "_gf-c";
export var headerTopRow = "_gf-b";
export var orderDetailsWrapper = "_gf-0";
export var orderInfoContainer = "_gf-1";
export var productDetails = "_gf-9";
export var productImage = "_gf-5";
export var responsiveTable = "_gf-8";
export var shipmentContainer = "_gf-a";
export var tableBottomLeft = "_gf-6";
export var tableBottomRight = "_gf-7";
export var trackingLink = "_gf-g";